/**
 * Copyright (C) SiteVision AB 2002-2023, all rights reserved
 *
 */

if (document.querySelector('.sv-twittersearch-portlet')) {
  import(/* webpackChunkName: "relativeDateUtil" */ '../util/relativeDateUtil');
}
